import { useEffect, useState } from 'react';
import { getGoogleUserIdFromParameter } from 'lib/auth';

export function useGoogleUserIdFromParameter() {
  const [googleUserId, setGoogleUserId] = useState<string>();

  useEffect(() => {
    const gUser = getGoogleUserIdFromParameter();
    if (gUser) setGoogleUserId(gUser);
  }, []);

  return googleUserId;
}
